import type { HTMLAttributes } from "react"
import { cn } from "@/lib/utils"

export function Kbd({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-pill border border-rule bg-surface px-1 font-mono text-[12px] text-muted",
        className,
      )}
      {...props}
    />
  )
}
